import { baseApi } from "./baseApi";

const CUSTOMER_USER_BASE_URL = "/customerUser";

export const customerUserApi = baseApi.injectEndpoints({

  tagTypes: ["CustomerUser"],
  endpoints: (builder) => ({
    getCustomerUserListData: builder.query({
      query: (params) => ({
        url: `${CUSTOMER_USER_BASE_URL}/list`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({ type: "CustomerUser", id: _id })),
              { type: "CustomerUser", id: "LIST" },
            ]
          : [{ type: "CustomerUser", id: "LIST" }],
    }),

    createCustomerUserData: builder.mutation({
      query: (payload) => ({
        url: `${CUSTOMER_USER_BASE_URL}/create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "CustomerUser", id: "LIST" },
      ],
    }),

    getCustomerUserDataDetail: builder.query({
      query: (id) => `${CUSTOMER_USER_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "CustomerUser", id },
        { type: "CustomerUser", id: "LIST" },
      ],
    }),

    updateCustomerUserData: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${CUSTOMER_USER_BASE_URL}/${_id}`,
          method: "PUT",
          body: {
            ...body,
            typeRefSource: "Customer",
          }
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "CustomerUser", _id },
        { type: "CustomerUser", id: "LIST" },
      ],
    }),

    getDDLCustomerUserList: builder.query({
      query: () => `${CUSTOMER_USER_BASE_URL}/ddl`,
    }),
  }),
});

export const {
  useGetCustomerUserListDataQuery,
  useLazyGetCustomerUserListDataQuery,
  useLazyGetDDLCustomerUserListQuery,
  useCreateCustomerUserDataMutation,
  useGetCustomerUserDataDetailQuery,
  useUpdateCustomerUserDataMutation,
} = customerUserApi;



